<!-- UpdateModal.vue component -->
<template>
  <div v-if="show" class="modal-overlay">
    <div class="fixed inset-0 z-40 bg-black opacity-50"></div>

    <div
      class="modal-content w-full max-h-[90vh] relative bg-white m-auto flex-col flex rounded-lg z-50"
    >
      <div class="w-full border-b-[1px] mb-4 px-6 py-4">
        <h2 class="text-[18px] text-grayDark font-bold">{{ modalTitle }}</h2>
      </div>

      <form @submit.prevent="submitForm" class="overflow-y-auto px-6">
        <div class="mb-4 space-y-4">
          <!-- Bio field -->
          <div v-if="fieldType === 'bio'">
            <label class="block text-[13px] font-medium text-grayDark"
              >Bio</label
            >
            <textarea
              v-model="formData.bio"
              placeholder="Enter a brief description of yourself"
              class="mt-1 block w-full h-[152px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              required
            ></textarea>
          </div>

          <!-- Portfolio URL field -->
          <div v-if="fieldType === 'portfolio'">
            <label class="block text-[13px] font-medium text-grayDark"
              >Portfolio URL</label
            >
            <input
              type="text"
              v-model="formData.portfolio_url"
              placeholder="https://your-portfolio.com"
              class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              required
            />
          </div>

          <!-- Position field -->
          <div v-if="fieldType === 'position'">
            <label class="block text-[13px] font-medium text-grayDark"
              >Position</label
            >
            <input
              type="text"
              v-model="formData.position"
              placeholder="e.g. Software Engineer"
              class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              required
            />
          </div>
          <div v-if="fieldType === 'skills'">
            <label class="block text-[13px] font-medium text-grayDark"
              >Skills</label
            >
            <input
              type="text"
              v-model="formData.skills"
              placeholder="e.g. Javascript"
              class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              required
            />
          </div>
        </div>

        <div class="flex justify-end mb-4 text-[14px]">
          <button
            type="button"
            class="mr-4 py-2 px-4 bg-primaryLight border border-grayLight text-grayDark rounded cursor-pointer"
            @click="closeModal"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="flex items-center gap-2 py-2 px-4 bg-primaryDarkBg w-[] h-[42px] text-white rounded"
          >
            <img src="@/assets/dashboard/add.svg" alt="User icon" class="h-4" />
            {{ submitButtonText }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";


export default {
  name: "UpdateModal",
  components: {},
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    fieldType: {
      type: String,
      required: true,
      validator: (value) =>
        ["bio", "portfolio", "position", "skills"].includes(value),
    },
    currentValue: {
      type: [String, Object],
      default: "",
    },
    talentData: {
      // Add this new prop
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {
        bio: "",
        portfolio_url: "",
        position: "",
      },
      isSubmitting: false,
    };
  },
  computed: {
    modalTitle() {
      const titles = {
        bio: "Update Bio",
        portfolio: "Update Portfolio URL",
        position: "Update Position",
      };
      return titles[this.fieldType] || "Update Profile";
    },
    submitButtonText() {
      return this.isCreating
        ? `Create ${this.capitalizeFirstLetter(this.fieldType)}`
        : `Update ${this.capitalizeFirstLetter(this.fieldType)}`;
    },
    isCreating() {
      // Check if we're creating a new field or updating an existing one
      return !this.formData[
        this.fieldType === "portfolio" ? "portfolio_url" : this.fieldType
      ];
    },
    userId() {
      return this.$store.getters.userId;
    },
    //   talentId() {
    //     return this.$store.getters.talentId;
    //   },
  },
  watch: {
    currentValue: {
      immediate: true,
      handler(newVal) {
        this.initializeFormData(newVal);
      },
    },
    show(newVal) {
      if (newVal) {
        this.initializeFormData(this.currentValue);
      }
    },
  },
  methods: {
    initializeFormData(value) {
      if (this.fieldType === "bio") {
        this.formData.bio = value || "";
      } else if (this.fieldType === "portfolio") {
        this.formData.portfolio_url = value || "";
      } else if (this.fieldType === "position") {
        this.formData.position = value || "";
      } else if (this.fieldType === "skills") {
        this.formData.skills = value || "";
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    closeModal() {
      this.$emit("close");
    },
    async submitForm() {
      this.isSubmitting = true;

      try {
        let response;
        const talentId = this.talentData?.talent_id;
        console.log("talent_id", talentId);

        // Handle different endpoints based on field type
        if (this.fieldType === "bio") {
          // Send bio update to user profile endpoint
          // response = await apiClient.put(`/web/settings/${this.userId}`, {
          response = await apiClient.put(`/web/settings/user/bio`, {
            bio: this.formData.bio,
          });
        } else {
          // Send portfolio/position update to talent profile endpoint
          const payload = {
            email: this.talentData?.talent_email,
            position: this.talentData?.position,
            portfolio_url: this.talentData?.portfolio_url,
          };
          console.log(this.talentData);
          if (this.fieldType === "portfolio") {
            payload.portfolio_url = this.formData.portfolio_url;
          } else if (this.fieldType === "position") {
            payload.position = this.formData.position;
          }
          response = await apiClient.patch(`/web/talent/${talentId}`, payload);
          console.log("response is", response);
        }

        // Show success message and emit update event
        this.$toast.success(`${this.capitalizeFirstLetter(this.fieldType)} updated successfully`);
        this.$emit("updated", {
          type: this.fieldType,
          value:
            this.fieldType === "portfolio"
              ? this.formData.portfolio_url
              : this.formData[this.fieldType],
        });

        // Close modal after a short delay
        setTimeout(() => {
          this.closeModal();
        }, 500);
      } catch (error) {
        console.error(`Error updating ${this.fieldType}:`, error);
        this.$toast.error(
          error.response?.data?.message ||
          `Failed to update ${this.fieldType}. Please try again.`
        );
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
}

.modal-content {
  width: 100%;
  max-width: 500px;
}
</style>
